/*
 * View for selecting an epc Code, including a nav tree
 * and a selectable list for showing the contents of a folder
 */

define([
  "marionette",
  "modules/shared/epcMappingModal/template/epcMappingModalTemplate.html",
], function (Marionette, EpcMappingModalTemplate) {
  var epcMappingModalTemplate = {};

  epcMappingModalTemplate.epcMappingModalLayout = Marionette.Layout.extend({
    template: EpcMappingModalTemplate,
    regions: {
      navTree: "#navTree",
      navList: "#navList",
    },
    triggers: {
      "click #doneButton": "done",
      "click #cancelButton": "cancel",
    },
    clearError: function () {
      this.$el.find("#epcError").html("");
    },
    epcError: function (errorMessage) {
      this.$el
        .find("#epcError")
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
  });

  return epcMappingModalTemplate;
});
